import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
} from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import PageContainer from '../components/shared/pageContainer';
import PageHeader from '../components/shared/page-header';
import { useGlobalState } from '../global/context/global-context';

export function TermsOfUseComponent() {
  const { applicationData } = useGlobalState();
  const entityName = applicationData?.entity?.nickName || 'Prefeitura Municipal';

  return (
    <PageContainer>
      <Container maxWidth="lg">
        <PageHeader
          title="Termos de Uso"
          subtitle="Condições de uso do portal"
          breadcrumbs={[
            { label: 'Termos de Uso' },
          ]}
        />

        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mb: 4,
              pb: 2,
              borderBottom: '2px solid',
              borderColor: 'primary.main',
            }}
          >
            <GavelIcon sx={{ fontSize: 40, color: 'primary.main' }} />
            <Typography variant="h4" component="h2" sx={{ fontWeight: 600 }}>
              Termos e Condições de Uso
            </Typography>
          </Box>

          <Box sx={{ '& > *': { mb: 3 } }}>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                1. Aceitação dos Termos
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Ao acessar e usar o portal da {entityName}, você concorda em cumprir e estar vinculado aos
                seguintes termos e condições de uso. Se você não concordar com qualquer parte destes termos,
                não deverá usar este portal.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                2. Uso do Portal
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mb: 2 }}>
                O portal da {entityName} foi desenvolvido para:
              </Typography>
              <Box component="ul" sx={{ pl: 4, color: 'text.secondary' }}>
                <li>Fornecer informações sobre serviços públicos municipais</li>
                <li>Promover a transparência da gestão pública</li>
                <li>Facilitar o acesso dos cidadãos a documentos e publicações oficiais</li>
                <li>Divulgar notícias e eventos do município</li>
                <li>Permitir o contato entre cidadãos e a administração pública</li>
              </Box>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                3. Propriedade Intelectual
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Todo o conteúdo presente neste portal, incluindo textos, gráficos, logotipos, imagens e software,
                é de propriedade da {entityName} ou de seus fornecedores de conteúdo e está protegido por leis
                de direitos autorais brasileiras e internacionais.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                4. Responsabilidades do Usuário
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mb: 2 }}>
                Ao utilizar este portal, você se compromete a:
              </Typography>
              <Box component="ul" sx={{ pl: 4, color: 'text.secondary' }}>
                <li>Não usar o portal para fins ilegais ou não autorizados</li>
                <li>Não transmitir vírus, malware ou qualquer código malicioso</li>
                <li>Não tentar obter acesso não autorizado a sistemas ou dados</li>
                <li>Fornecer informações verdadeiras e atualizadas quando solicitado</li>
                <li>Respeitar os direitos de propriedade intelectual</li>
              </Box>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                5. Links para Sites de Terceiros
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Este portal pode conter links para sites de terceiros. A {entityName} não é responsável pelo
                conteúdo ou práticas de privacidade destes sites. O acesso a sites de terceiros é por sua conta
                e risco.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                6. Disponibilidade do Serviço
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Embora nos esforcemos para manter o portal sempre disponível, não garantimos que o serviço será
                ininterrupto ou livre de erros. Podemos suspender, retirar ou restringir a disponibilidade de
                todo ou parte do portal por razões operacionais ou de manutenção.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                7. Limitação de Responsabilidade
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                A {entityName} não será responsável por quaisquer danos diretos, indiretos, incidentais,
                consequenciais ou punitivos resultantes do uso ou incapacidade de usar este portal, mesmo que
                tenhamos sido avisados da possibilidade de tais danos.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                8. Modificações dos Termos
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão em
                vigor imediatamente após sua publicação no portal. O uso continuado do portal após tais
                modificações constitui sua aceitação dos novos termos.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                9. Lei Aplicável
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Estes termos são regidos pelas leis da República Federativa do Brasil. Qualquer disputa
                relacionada a estes termos será resolvida nos tribunais competentes da comarca do município.
              </Typography>
            </Box>

            <Divider />

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
                10. Contato
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco através dos canais
                oficiais da {entityName} disponíveis neste portal.
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 4,
                pt: 3,
                borderTop: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                Última atualização: {new Date().toLocaleDateString('pt-BR', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric'
                })}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </PageContainer>
  );
}
